function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.286 1.714H12.57V.571a.571.571 0 10-1.142 0v1.143H4.57V.571a.571.571 0 10-1.142 0v1.143H1.714C.768 1.714 0 2.482 0 3.43v10.857C0 15.233.768 16 1.714 16h12.572c.947 0 1.714-.768 1.714-1.714V3.429c0-.947-.768-1.715-1.714-1.715zm.571 12.572a.571.571 0 01-.571.571H1.714a.571.571 0 01-.571-.571V6.857h13.714v7.429zm0-8.572H1.143V3.43c0-.316.256-.572.571-.572H3.43V4A.571.571 0 104.57 4V2.857h6.858V4a.571.571 0 101.143 0V2.857h1.714c.315 0 .571.256.571.572v2.285z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.571 8H3.43a.571.571 0 100 1.143H4.57a.571.571 0 100-1.143zM8.571 8H7.43a.571.571 0 100 1.143H8.57a.571.571 0 100-1.143zM12.572 8h-1.143a.571.571 0 000 1.143h1.143a.571.571 0 000-1.143zM4.571 10.286H3.43a.571.571 0 000 1.143H4.57a.571.571 0 100-1.143zM8.571 10.286H7.43a.571.571 0 000 1.143H8.57a.571.571 0 100-1.143zM12.572 10.286h-1.143a.571.571 0 000 1.143h1.143a.571.571 0 100-1.143zM4.571 12.571H3.43a.571.571 0 100 1.143H4.57a.571.571 0 100-1.143zM8.571 12.571H7.43a.571.571 0 100 1.143H8.57a.571.571 0 000-1.143zM12.572 12.571h-1.143a.571.571 0 100 1.143h1.143a.571.571 0 000-1.143z"
});

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgCalendar;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/calendar.svg
// module id = 1285
// module chunks = 10